export const Theme = {
	initBannerBg: () => {
		const bannerBgElmts = document.querySelectorAll( '.with-banner-bg' );
		bannerBgElmts.forEach( ( container ) => {
			const bgElmt = document.createElement( 'div' );
			bgElmt.classList.add( 'banner-bg' );
			bgElmt.innerHTML = '<div class="banner-bg-inner"><div><div><div><div></div></div></div></div></div>';
			container.appendChild( bgElmt );
		} );
	},
	initMobileMenu: () => {
		const menu = document.getElementById( 'navbarPrimaryMenu' );
		menu.addEventListener( 'show.bs.collapse', () => {
			document.body.classList.add( 'mobile-menu-open' );
		} );
		menu.addEventListener( 'hide.bs.collapse', () => {
			document.body.classList.remove( 'mobile-menu-open' );
		} );
		const parentMenuItems = document.querySelectorAll( '#navbarPrimaryMenu .menu-item-has-children:not(.current_page_item):not(.current_page_parent) > a' );
		parentMenuItems.forEach( ( parentMenuItem ) => {
			parentMenuItem.addEventListener( 'click', ( event ) => {
				// If mobile menu is not opened, skip
				if ( ! document.body.classList.contains( 'mobile-menu-open' ) ) {
					return true;
				}
				const parent = event.target.parentElement;
				if ( parent.classList.contains( 'open' ) ) {
					return true;
				}
				parent.classList.add( 'open' );
				event.preventDefault();
				return false;
			} );
		} );
	},
};
